export function isEqualCaseInsensitive(one: string, other: string): boolean {
  return one.toLowerCase() == other.toLowerCase()
}

export function convertToBoolean(value: string): boolean {
  if (value.toLowerCase() === 'true') {
    return true
  }

  return false
}
